import { type ReactNode } from 'react';

import { Div } from '@ui/components/layout/Div';
import { cn } from '@ui/lib/utils';
import { ZIndex } from '@ui/zIndexUtils';

type FloatingBannerTone = 'warn';

const TONE_CLASSNAMES: Record<FloatingBannerTone, string> = {
  warn: 'bg-warn text-fg-inverse',
};

const FLOATING_BANNER_CLASSNAME = [
  'fixed top-4 left-1/2 -translate-x-1/2 items-center gap-4',
  'max-w-[calc(100vw-32px)] rounded-xl py-2 pr-3 pl-5 shadow-elevation-3',
].join(' ');

interface FloatingBannerProps {
  children: ReactNode;
  tone?: FloatingBannerTone;
  className?: string;
}

const FloatingBanner = ({ children, tone = 'warn', className }: FloatingBannerProps) => (
  <Div
    row
    role="status"
    style={{ zIndex: ZIndex.FLOATING_BANNER }}
    className={cn(FLOATING_BANNER_CLASSNAME, TONE_CLASSNAMES[tone], className)}
  >
    {children}
  </Div>
);

export { FloatingBanner };
export type { FloatingBannerProps, FloatingBannerTone };
